<template>
    <div v-if="orden_venta">
        <Box  @close="close({})">
            <template v-slot:top>Pedido: {{ orden_venta.ovt_id }}</template>
            <template v-slot:center>
                <div class="nj-cols">
                    <div class="nj-card nj-cols">
                        <div class="nj-subtitle-1">Cliente</div>
                        <InputForm text="Cliente">
                            <input type="text" class="nj-text" v-model="orden_venta.cli_nombre" disabled>
                        </InputForm>
                        <div class="nj-subtitle-1">Contacto Receptor</div>
                        <div class="nj-cols form c4">
                            <InputForm text="Nombres y apellidos">
                                <input type="text" class="nj-text" v-model="orden_venta.ovt_nombre_contacto" disabled>
                            </InputForm>
                            <InputForm text="Documento identidad">
                                <input type="text" class="nj-text" v-model="orden_venta.ovt_documento_identidad_contacto" disabled>
                            </InputForm>
                            <InputForm text="Telefono / Celular">
                                <input type="text" class="nj-text" v-model="orden_venta.ovt_telefono_contacto" disabled>
                            </InputForm>
                            <InputForm text="Correo">
                                <input type="text" class="nj-text" v-model="orden_venta.ovt_correo_contacto" disabled>
                            </InputForm>
                        </div>
                    </div>
                    <div class="nj-card nj-cols">
                        <div class="nj-subtitle-1">Pedido</div>
                        <div class="nj-cols form">
                            <div class="nj-cols form c5">
                                <InputForm text="Vendedor">
                                    <input type="text" class="nj-text" v-model="orden_venta.ven_nombre" disabled>
                                </InputForm>
                                <InputForm text="Fecha y hora solicitada">
                                    <div class="nj-flx">
                                        <Fecha :data="fecha_hora" :disabled="true" />
                                        <Hora :data="fecha_hora" :disabled="true" />
                                    </div>
                                </InputForm>
                                <InputForm text="Tipo de comprobante">
                                    <select class="nj-select" v-model="orden_venta.tid_id" disabled>
                                        <option></option>
                                        <option v-for="item in tipos_documento" :key="item.tid_id" :value="item.tid_id">{{ item.tid_descripcion }}</option>
                                    </select>
                                </InputForm>
                                <InputForm text="Condición de pago">
                                    <select class="nj-select" v-model="orden_venta.coc_id" disabled>
                                        <option></option>
                                        <option v-for="item in condiciones_comerciales" :key="item.coc_id" :value="item.coc_id">{{ item.coc_descripcion }}</option>
                                    </select>
                                </InputForm>
                                <InputForm text="Numero comprobante">
                                    <input type="text" class="nj-text" v-model="orden_venta.ovt_comprobante" disabled>
                                </InputForm>
                            </div>
                            <InputForm text="Observaciones">
                                <textarea class="nj-text" cols="30" rows="4" v-model="orden_venta.ovt_observaciones" disabled></textarea>
                            </InputForm>
                        </div>
                        <div class="nj-subtitle-1">Dirección de envio</div>
                        <div class="nj-cols c3 form">
                            <div>
                                <div class="nj-label">Dirección</div>
                                <input type="text" class="nj-text" v-model="orden_venta.ovt_direccion_envio" disabled>
                            </div>
                            <div>
                                <div class="nj-label">Referencia</div>
                                <input type="text" class="nj-text" v-model="orden_venta.ovt_referencia_envio" disabled>
                            </div>
                            <InputForm text="Distrito">
                                <select class="nj-select" v-model="orden_venta.ubi_id" disabled>
                                    <option></option>
                                    <option v-for="item in distritos" :key="item.ubi_id" :value="item.ubi_id">{{ item.ubi_nombre }}</option>
                                </select>
                            </InputForm>
                        </div>
                    </div>
                    <div class="nj-card">
                        <div class="nj-subtitle-1">Productos</div>
                        <br>
                        <div class="nj-scroll-x">
                            <div class="data-grid">
                                <div class="data-grid-title cols">
                                    <div>Producto</div>
                                    <div>Min. - Max.</div>
                                    <div>Precio</div>
                                    <div>Cantidad</div>
                                    <div>Importe</div>
                                    <div></div>
                                </div>
                                <div class="data-grid-body cols" v-for="item in orden_venta.lista_orden_venta_detalle" :key="item.sequence">
                                    <div>{{ item.ovd_producto }}</div>
                                    <div class="nj-text-center">S/ {{ item.pvt_precio_minimo }} - S/ {{ item.pvt_precio }}</div>
                                    <div>
                                        <input type="text" class="nj-text nj-text-right" v-model="item.ovd_precio" @keyup="calcular()" disabled>
                                    </div>
                                    <div>
                                        <input type="text" class="nj-text nj-text-right" v-model="item.ovd_cantidad" @keyup="calcular()" disabled>
                                    </div>
                                    <div>
                                        <input type="text" class="nj-text nj-text-right" v-model="item.ovd_subtotal" disabled>
                                    </div>
                                    <div></div>
                                </div>
                                <template v-if="orden_venta.lista_orden_venta_detalle.length != 0">
                                    <div class="data-grid-footer cols">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div class="nj-text-right nj-bold">Subtotal</div>
                                        <div>
                                            <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_subtotal" disabled>
                                        </div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div class="data-grid-footer cols">
                                        <div></div>
                                        <div></div>
                                        <div class="nj-text-right nj-bold">IGV</div>
                                        <div>
                                            <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_igv_tasa" @keyup="calcular()" disabled>
                                        </div>
                                        <div>
                                            <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_igv" disabled>
                                        </div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div class="data-grid-footer cols">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div class="nj-text-right nj-bold">Total</div>
                                        <div>
                                            <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_total" disabled>
                                        </div>
                                        <div></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="nj-card">
                        <div class="nj-flx justify-between">
                            <div class="nj-subtitle-1">Pagos</div>
                            <Button icon="add" color="green" label="Nuevo" @click="popup({ componente: 'registrarPago', status: true, ovt_id: ovt_id })" activationCode="registrarOrdenVentaPago"></Button>
                        </div>
                        <br>
                        <b-table :data="orden_venta.lista_orden_venta_pago">
                            <template slot-scope="props">
                                <b-table-column label="N°">{{ props.row.ovp_orden }}</b-table-column>
                                <b-table-column label="Descripción">{{ props.row.ovp_descripcion }}</b-table-column>
                                <b-table-column label="Fecha">{{ props.row.ovp_fecha_pago }}</b-table-column>
                                <b-table-column label="Monto">{{ props.row.ovp_monto }}</b-table-column>
                                <b-table-column label="Estado">{{ props.row.est_nombre }}</b-table-column>
                                <b-table-column label="" style="text-align: center;">
                                    <div class="nj-flx">
                                        <Button type="icon" icon="delete" color="red" title="Eliminar" @click="cancelarPago(props.row)"></Button>
                                        <Button type="icon" icon="attachment" color="blue" title="Ver documento" @click="abrirDocumento(props.row)"></Button>
                                    </div>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                    <div class="nj-card">
                        <div class="nj-subtitle-1">Comprobantes</div>
                        <br>
                        <div class="nj-flx">
                            <Button label="Generar comprobante" color="blue" icon="doc" @click="generarComprobante()" :activation="activarGenerarComprobante()"></Button>
                            <Button :label="comprobante.nco_id" icon="pdf" @click="verComprobante(comprobante)" v-for="comprobante in orden_venta.lista_nube_fact_comprobante" :key="comprobante.nco_id"></Button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:bottom>
                <Button label="Aprobar" color="green" icon="review" @click="aprobar()" activationCode="aprobar_orden_venta" :activation="activarAprobacion()"></Button>
            </template>
        </Box>
        <RegistrarOrdenVentaPago v-if="activarRegistrarPago" :ovt_id="orden_venta.ovt_id" @close="popup($event)"></RegistrarOrdenVentaPago>
    </div>
</template>

<script>
import { mapActions } from "vuex"
import { AppService, ClienteService, OrdenVentaPagoService, OrdenVentaService, ResponseStatus, UsuarioService } from "../../services"
import Arrays from "../../util/arrays"
import Confirm from "../../util/confirm"
import DateTime from "../../util/dateTime"
import Numbers from "../../util/numbers"
import Toast from "../../util/toast"
import RegistrarCliente from "../cliente/RegistrarCliente.vue"
import { Button, Fecha, Hora, InputForm, Box, Search } from "../components"
import RegistrarOrdenVentaPago from "../ordenVentaPago/RegistrarOrdenVentaPago.vue"
import { EstadoEnum } from "../../constants"

export default {
    components: {
        Fecha,
        Hora,
        Box,
        InputForm,
        RegistrarCliente,
        Search,
        RegistrarOrdenVentaPago,
        Button,
    },
    name: "VerOrdenVenta",
    data() {
        return {
            orden_venta: null,
            sequence: 1,
            clientes: [],
            vendedores: [],
            productos: [],
            distritos: [],
            estados: [],
            ven_nombre: null,
            pvt_search: null,
            monedas: [],
            condiciones_comerciales: [],
            tipos_documento: [],
            direcciones_envio: [],
            pagos: [],
            fecha_hora: {
                day: null,
                month: null,
                year: null,
                hour: null,
                min: null,
            },
            activarRegistrarPago: false,
        }
    },
    props: {
        ovt_id: {
            type: Number
        },
        lista_tipo_documento_identidad: {
            type: Array
        },
    },
    computed: {
        cli_nombre() {
            return `${this.orden_venta.cli_documento_identidad} ${this.orden_venta.cli_nombre}`
        }
    },
    methods: {
        ...mapActions("AppStore", [
            "_loadingOn",
            "_loadingOff",
        ]),
        getDireccion(direccion) {
            return `(${direccion.cde_alias}) ${direccion.cde_direccion}, ${direccion.referencia ? direccion.referencia : '-'}, ${direccion.cde_distrito}`
        },
        seleccionarVendedor(vendedor) {
            this.orden_venta.ven_id = vendedor.ven_id
            this.ven_nombre = vendedor.ven_documento_identidad + " " + vendedor.ven_nombre
            this.vendedores = []
        },
        agregarProducto(producto) {
            const prod = this.orden_venta.lista_orden_venta_detalle.find(i => i.pvt_id == producto.pvt_id)
            if (!prod) {
                this.orden_venta.lista_orden_venta_detalle.push({
                    sequence: this.sequence,
                    pvt_id: producto.pvt_id,
                    ovd_producto: producto.pvt_nombre,
                    ovd_precio: producto.pvt_precio,
                    ovd_cantidad: 1,
                    ovd_moneda: producto.unm_simbolo,
                    ovd_moneda_descripcion: producto.unm_descripcion,
                    ovd_subtotal: 0
                })
                this.sequence++
                this.calcular()
                this.productos = []
                this.$refs.pvt_search.select()
            }
            else {
                Toast.error("El producto ya ha sido agregado")
            }
        },
        removerProducto(sequence) {
            this.orden_venta.lista_orden_venta_detalle = this.orden_venta.lista_orden_venta_detalle.filter(item => item.sequence != sequence)
            this.calcular()
        },
        reinciar() {
            this.orden_venta.lista_orden_venta_detalle.forEach(producto => {
                producto.ovd_subtotal = producto.ovd_total = 0
                producto.ovd_igv = 0
                producto.ovd_total = 0
            })
            this.orden_venta.ovt_subtotal = 0
            this.orden_venta.ovt_igv = 0
            this.orden_venta.ovt_total = 0
        },
        calcular() {
            this.reinciar()
            // calculando los valores por item
            this.orden_venta.lista_orden_venta_detalle.forEach(producto => {
                producto.ovd_subtotal = producto.ovd_total = Numbers.round(producto.ovd_precio * producto.ovd_cantidad)
                if (this.orden_venta.ovt_igv_tasa) {
                    // calculado el igv
                    producto.ovd_igv = Numbers.round(producto.ovd_subtotal * parseFloat(this.orden_venta.ovt_igv_tasa))
                    producto.ovd_total = Numbers.round(producto.ovd_subtotal + producto.ovd_igv)
                }
            })
            // calculando los valores por orden de venta
            this.orden_venta.lista_orden_venta_detalle.forEach(item => {
                this.orden_venta.ovt_subtotal += item.ovd_subtotal
                this.orden_venta.ovt_igv += item.ovd_igv
                this.orden_venta.ovt_total += item.ovd_total
            })
            // redondeando el total al final de todos los calculos
            this.orden_venta.ovt_total = Numbers.round(this.orden_venta.ovt_total)
        },
        popup({
            componente,
            status,
            renderizar = false,
            ovt_id = null
        }) {
            switch (componente) {
                case "registrarPago":
                    this.activarRegistrarPago = status
                    break
                default: {
                    this.activarRegistrarPago = status
                }
            }
            this.ovt_id = ovt_id
            if (renderizar) {
                this.obtener()
            }
        },
        aprobar() {
            Confirm.show({
                message: "¿Esta seguro de aprobar la orden de venta?",
                action: () => {
                    // el tipo indica si es una aprobación por pago parcial o total de la orden
                    OrdenVentaService.aprobar({
                        orden_venta: {
                            ovt_id: this.orden_venta.ovt_id,
                            coc_id: this.orden_venta.coc_id
                        }
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.close({
                                    renderizar: true
                                })
                            }
                            else {
                                Toast.error(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
            })
        },
        obtenerDirecciones() {
            ClienteService.obtenerDirecciones({
                cliente_direccion_envio: {
                    cli_id: this.orden_venta.cli_id
                }
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.direcciones_envio = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        obtener() {
            const request = {
                orden_venta: {
                    ovt_id: this.ovt_id
                }
            }
            OrdenVentaService
                .obtener(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.orden_venta = response.data
                        let counter = 1
                        this.orden_venta.lista_orden_venta_pago.forEach(item => {
                            item.ovp_orden = counter
                            counter++
                        })
                        this.fecha_hora = DateTime.convertStringToObject(this.orden_venta.ovt_fecha_entrega)
                        this.obtenerDirecciones()
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        cancelarPago(pago) {
            Confirm.show({
                message: `¿Esta seguro de cancelar el pago: "${pago.ovp_descripcion}"?`,
                action: () => {
                    const request = {
                        orden_venta_pago: {
                            ovp_id: pago.ovp_id
                        }
                    }
                    OrdenVentaPagoService
                        .cancelar(request)
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.obtener()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        })
                }
            })
        },
        abrirDocumento(pago) {
            if (pago.ovp_url_comprobante) {
                window.open(pago.ovp_url_comprobante, '_blank')
            }
            else {
                Toast.error("El pago no tiene documento adjunto")
            }
        },
        activarAprobacion() {
            return this.orden_venta.est_id == EstadoEnum.CREADO.est_id
        },
        activarGenerarComprobante() {
            return this.orden_venta.est_id == EstadoEnum.PAGADO.est_id
                && this.orden_venta.lista_nube_fact_comprobante.length == 0
                && this.orden_venta.cli_especial == 0
        },
        activarVerComprobante() {
            return this.orden_venta.est_id == EstadoEnum.PAGADO.est_id
                && this.orden_venta.ovt_comprobante != null
                && this.orden_venta.ovt_comprobante_enlace != null
        },
        close({
            componente = "ver",
            status = false,
            renderizar = false
        }) {
            this.$emit("close", {
                componente,
                status,
                renderizar
            })
        },
        generarComprobante() {
            Confirm.show({
                message: "¿Desea continuar con la generación del comprobante?",
                action: () => {
                    const request = {
                        orden_venta: {
                            ovt_id: this.orden_venta.ovt_id
                        }
                    }
                    OrdenVentaService
                        .generarComprobante(request)
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.obtener()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        })
                }
            })
        },
        verComprobante(comprobante) {
            window.open(comprobante.nco_enlace, "_blank")
        },
    },
    beforeMount() {
        UsuarioService.obtenerOpciones()
    },
    mounted() {
        AppService
            .getData(["tipos_documento", "condiciones_comerciales", "monedas", "distritos", "estados"])
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    if (ResponseStatus.isSuccess(response)) {
                        this.estados = response.data.estados
                        this.tipos_documento = Arrays.filter(response.data.tipos_documento, "tid_descripcion", ["BOLETA", "FACTURA"])
                        this.condiciones_comerciales = response.data.condiciones_comerciales
                        this.distritos = response.data.distritos
                        this.obtener()
                    }
                    else {
                        Toast.error(response.message)
                    }
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
                console.error(`error: `, error)
            })
    }
}
</script>

<style scoped>
.data-grid {
    min-width: 800px;
}

.cols {
    --cols: 1fr 100px 100px 100px 100px 100px;
}

.data-grid-title {
    display: grid;
    grid-template-columns: var(--cols);
    background-color: #0077b6;
    color: #fff;
    align-items: center;
}

.data-grid-body {
    display: grid;
    grid-template-columns: var(--cols);
    border: 1px solid #ccc;
    border-top: none;
    align-items: center;
}

.data-grid-body>div {
    padding: 6px 8px;
}

.data-grid-title>div {
    padding: 6px 8px;
    text-align: center;
}

.data-grid-footer {
    display: grid;
    grid-template-columns: var(--cols);
    align-items: center;
}

.data-grid-footer>div {
    padding: 6px 8px;
}

.documento {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    width: 120px;
    background-color: #f4f4f4;
    border: 1px solid #ccc;
    border-radius: 4px;
}
</style>